import styled from 'styled-components'

export default styled.ul`
  display: inline-block;
  margin: 0;
  padding: 0;
`
